import {AppliedFilterSection_Value} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {useFormatCurrency} from '@aboutyou/i18n';
import {useMemo} from 'react';

export const useNormalizedAppliedFilters = (
  appliedFilters: Array<AppliedFilterSection_Value>,
) => {
  const formatCurrency = useFormatCurrency();

  const getFormattedPrice = (
    min: number,
    max: number,
    currencyCode: string,
  ) => {
    return `${formatCurrency(min, currencyCode, {
      withoutDecimal: true,
    })} - ${formatCurrency(max, currencyCode, {
      withoutDecimal: true,
    })}`;
  };

  return useMemo(
    () =>
      appliedFilters.reduce((normalizedAppliedFilters, appliedFilter) => {
        const {slug, value} = appliedFilter;

        if (value?.$case === 'attribute') {
          const {id, label} = value.attribute;

          return [
            ...normalizedAppliedFilters,
            {
              id: `${id}`,
              label,
              slug,
            },
          ];
        }
        if (value?.$case === 'discountLevel') {
          const discountLevel = value.discountLevel;

          return [
            ...normalizedAppliedFilters,
            {
              id: `${discountLevel.value}`,
              label: discountLevel.label,
              slug,
            },
          ];
        }
        if (value?.$case === 'boolean') {
          const {label} = value.boolean;

          return [
            ...normalizedAppliedFilters,
            {
              id: 'true',
              label,
              slug,
            },
          ];
        }
        if (value?.$case === 'range') {
          const {max, min, currencyCode} = value.range;

          return [
            ...normalizedAppliedFilters,
            {
              id: `${min},${max}`,
              label: getFormattedPrice(min, max, currencyCode),
              slug,
            },
          ];
        }
        if (value?.$case === 'text') {
          const {label, text} = value.text;

          return [
            ...normalizedAppliedFilters,
            {
              id: text,
              label,
              slug,
            },
          ];
        }
        if (value?.$case === 'searchFilter') {
          const {id, label} = value.searchFilter;

          return [
            ...normalizedAppliedFilters,
            {
              id: `${id}`,
              label,
              slug,
            },
          ];
        }

        return normalizedAppliedFilters;
      }, [] as Array<{id: string; label: string; slug: string}>),
    [appliedFilters],
  );
};
